import React from 'react';
import { useFormikContext } from 'formik';
import { FormControl, InputLabel, MenuItem, Select, FormHelperText } from '@mui/material';
import { personType, translations } from '../../lib/consts';

type Props = {
    leasingEntityType: personType;
};

const LeasingEntity = ({ leasingEntityType }: Props) => {
    const { values, errors, touched, setFieldValue } = useFormikContext<any>();
    const id = `${personType[leasingEntityType]}LeasingEntityID`;

    const handleChangeLeasingEntity = (e: { target: { value: any } }): any => {
        setFieldValue(id, e.target.value);
        const selectedLeasingEntity = values.leasingEntities?.filter((option: any) => option.id === e.target.value);
        setFieldValue(`${personType[leasingEntityType]}LegalNameForDisplay`, selectedLeasingEntity[0].text);
    };
    return (
        <>
            <FormControl>
                <InputLabel id="leasing-entity-label">{translations.legalInfo.LEASING}</InputLabel>

                <Select
                    id={id}
                    labelId="leasing-entity-label"
                    name={id}
                    value={values[id] || ''}
                    label={translations.legalInfo.LEASING}
                    error={!!(touched[id] && errors[id])}
                    onChange={handleChangeLeasingEntity}
                >
                    {values.leasingEntities?.map((option: any, index: any) => {
                        return (
                            <MenuItem key={option.id} value={option.id}>
                                {option.text}
                            </MenuItem>
                        );
                    })}
                </Select>
                {touched[id] && errors[id] ? (
                    <FormHelperText error={true}>
                        <>{errors[id]}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};

export const LeasingEntityCleanup = (
    type: personType,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
) => {
    setFieldValue(`${personType[type]}LeasingEntityID`, '');
};

export default LeasingEntity;
